var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-wrap"},[_c('svg',{staticClass:"progress-circle svg-content",attrs:{"width":"100%","height":"100%","viewBox":"-1 -1 102 102"}},[_c('path',{attrs:{"d":"M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }